import script from "./FeanorResultPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FeanorResultPanel.vue?vue&type=script&setup=true&lang=js"

import "./FeanorResultPanel.vue?vue&type=style&index=0&id=055a4dfd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-055a4dfd"]])

export default __exports__